import { render, staticRenderFns } from "./modalGroceryBadObject.vue?vue&type=template&id=5cef365b&scoped=true&"
import script from "./modalGroceryBadObject.vue?vue&type=script&lang=js&"
export * from "./modalGroceryBadObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef365b",
  null
  
)

export default component.exports